export default __webpack_public_path__ + "static/media/bidifylogo_optimism.e9ee3355.png";